export { default } from './VariableInput.js';
